import { css } from '@emotion/react'
import { mq, z } from '@/styles'

export const styles = () => ({
  stage: {
    main: css`
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;

      width: 100%;
    `,

    backward: {
      main: css`
        z-index: ${z.onboarding.backward};

        position: fixed;
        top: 20px;
        left: 20px;
      `,
      button: css``,
      icon: css`
        width: 24px;
        height: 24px;
      `,
    },

    content: {
      main: css`
        display: flex;
        align-items: center;
        flex-direction: column;
      `,

      title: css`
        margin-bottom: 50px;
      `,

      form: css`
        margin-bottom: 32px;

        width: 380px;
        ${mq.mobile(css`
          width: 100%;
        `)}
      `,

      error: css``,
    },
  },
})
